import { Configuration } from "@azure/msal-browser";
import { GetHostHref } from "./SettingsMisc";

export const upnFromToken = (token: string): string => {
	try {
		const claims = JSON.parse(atob(token.split('.')[1]));
		return (claims.upn as string).toLowerCase()
	} catch (error) {
		return ""
	}
}

export const msalConfig = (): Configuration => {
	return {
		auth: {
			clientId: import.meta.env.VITE_CLIENT_ID || '',
			authority: import.meta.env.VITE_LOGIN_URL || 'https://login.microsoftonline.com/common/oauth2/v2.0',
			postLogoutRedirectUri: GetHostHref() + '/login',
			redirectUri: GetHostHref(),
			navigateToLoginRequestUrl: true,
		},
		cache: {
			cacheLocation: "localStorage",
		},
		system: {
			tokenRenewalOffsetSeconds: 300, // Adjust this as needed, e.g., 300 seconds (5 minutes) before token expiry.
		},
	}
}